import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.authoring.candidates');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { formatKstDateTime } from "src/libs/portal/season/time";

@Component({
    selector: 'wiz-page-authoring-candidates',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.authoring.candidates/view.scss */
:host {
  display: block;
  min-height: 100%;
}

* {
  box-sizing: border-box;
}

button, input, select {
  font: inherit;
}

.candidate-drive {
  position: relative;
  max-width: 1540px;
  min-height: 100vh;
  margin: 0 auto;
  padding: 24px 28px 36px;
  color: #22312c;
}

.drive-shell {
  min-height: 620px;
  display: grid;
  overflow: hidden;
  border: 1px solid #dfe6e3;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 1px 2px rgba(30, 50, 43, 0.03);
}

.drive-panel {
  position: relative;
  min-width: 0;
  min-height: inherit;
  display: flex;
  flex-direction: column;
  background: #fff;
}

.drive-loading-bar {
  position: absolute;
  z-index: 8;
  top: 0;
  right: 0;
  left: 0;
  height: 3px;
  overflow: hidden;
  background: #dceae5;
}

.drive-loading-bar i {
  position: absolute;
  width: 34%;
  height: 100%;
  background: #248765;
  animation: drive-loading 1s ease-in-out infinite;
}

@keyframes drive-loading {
  from {
    transform: translateX(-110%);
  }
  to {
    transform: translateX(300%);
  }
}
.drive-page-header {
  position: relative;
  z-index: 4;
  border-bottom: 1px solid #e7ecea;
  background: #fff;
}

.drive-navigation-bar {
  min-width: 0;
  min-height: 70px;
  display: flex;
  align-items: center;
  padding: 0 22px;
  border-bottom: 1px solid #edf1ef;
  gap: 22px;
}

.breadcrumbs {
  min-width: 0;
  display: flex;
  flex: 1 1 auto;
  align-items: center;
  overflow: hidden;
}

.breadcrumbs a, .breadcrumbs > span, .breadcrumbs h1 {
  flex: 0 1 auto;
  overflow: hidden;
  padding: 6px 7px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.breadcrumbs a {
  flex: 0 0 auto;
  color: #5b7067;
  font-size: 13px;
  font-weight: 700;
  text-decoration: none;
}

.breadcrumbs a:hover {
  color: #126149;
}

.breadcrumbs > span {
  max-width: 220px;
  color: #40584e;
  font-size: 13px;
}

.breadcrumbs h1 {
  max-width: 130px;
  margin: 0;
  color: #172f27;
  font-size: 14px;
  font-weight: 800;
}

.breadcrumbs > svg {
  width: 16px;
  height: 16px;
  flex: 0 0 auto;
  fill: none;
  stroke: #9aa7a1;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.8;
}

.drive-search {
  min-width: 260px;
  max-width: 520px;
  height: 42px;
  display: flex;
  flex: 0 1 460px;
  align-items: center;
  padding: 0 14px;
  border: 1px solid transparent;
  border-radius: 10px;
  background: #f1f4f3;
  gap: 11px;
}

.drive-search:focus-within {
  border-color: #c9d7d2;
  background: #fff;
  box-shadow: 0 2px 8px rgba(33, 58, 49, 0.09);
}

.drive-search > svg {
  width: 19px;
  height: 19px;
  flex: 0 0 auto;
  fill: none;
  stroke: #61736c;
  stroke-linecap: round;
  stroke-width: 1.8;
}

.drive-search input {
  min-width: 0;
  flex: 1;
  border: 0;
  outline: 0;
  color: #263b34;
  background: transparent;
  font-size: 13px;
}

.drive-search > button {
  width: 28px;
  height: 28px;
  display: grid;
  padding: 0;
  border: 0;
  border-radius: 50%;
  place-items: center;
  color: #6e7d78;
  background: transparent;
  cursor: pointer;
  font-size: 18px;
}

.drive-command-bar {
  min-height: 56px;
  display: flex;
  align-items: center;
  padding: 8px 22px;
  background: #fbfcfc;
  gap: 12px;
}

.status-filters {
  min-width: 0;
  display: flex;
  flex: 0 1 auto;
  align-items: center;
  overflow-x: auto;
  gap: 7px;
}

.status-filters button {
  min-height: 30px;
  display: inline-flex;
  align-items: center;
  padding: 0 11px;
  border: 1px solid #d6dfdb;
  border-radius: 8px;
  color: #4f625a;
  background: #fff;
  cursor: pointer;
  font-size: 12px;
  white-space: nowrap;
  gap: 6px;
}

.status-filters button.active {
  border-color: #7fae9d;
  color: #0d684e;
  background: #edf6f2;
  font-weight: 750;
}

.status-filters small {
  color: #6f7f78;
  font-size: 11px;
}

.list-utilities {
  min-width: 0;
  display: flex;
  flex: 1 1 auto;
  align-items: center;
  justify-content: flex-end;
  margin-left: auto;
  gap: 8px;
}

.run-filter select {
  max-width: 290px;
  height: 34px;
  border: 1px solid #d4dfda;
  border-radius: 8px;
  padding: 0 30px 0 10px;
  color: #40564d;
  background: #fff;
  font-size: 11px;
}

.location-count {
  max-width: 240px;
  overflow: hidden;
  color: #697a73;
  font-size: 11px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.command-icon-button {
  position: relative;
  width: 38px;
  height: 38px;
  display: grid;
  flex: 0 0 auto;
  padding: 0;
  border: 1px solid transparent;
  border-radius: 10px;
  place-items: center;
  color: #50645c;
  background: transparent;
  cursor: pointer;
}

.command-icon-button:hover {
  color: #126149;
  background: #e9f0ed;
}

.command-icon-button:disabled {
  cursor: default;
  opacity: 0.38;
}

.command-icon-button svg {
  width: 19px;
  height: 19px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.8;
}

.command-icon-button[data-tooltip]::after {
  position: absolute;
  right: 0;
  bottom: calc(100% + 6px);
  z-index: 24;
  padding: 6px 8px;
  border-radius: 6px;
  opacity: 0;
  color: #fff;
  background: #263b34;
  content: attr(data-tooltip);
  font-size: 11px;
  font-weight: 700;
  pointer-events: none;
  white-space: nowrap;
}

.command-icon-button[data-tooltip]:hover::after {
  opacity: 1;
}

.drive-content {
  min-height: 380px;
  flex: 1;
  padding: 22px;
}

.folder-loading-state {
  min-height: 330px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #667770;
  font-size: 13px;
  gap: 12px;
}

.state-spinner {
  width: 22px;
  height: 22px;
  display: inline-block;
  border: 2px solid #d8e3de;
  border-top-color: #238361;
  border-radius: 50%;
  animation: state-spin 0.8s linear infinite;
}

@keyframes state-spin {
  to {
    transform: rotate(360deg);
  }
}
.inline-error {
  min-height: 52px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  padding: 10px 13px;
  border: 1px solid #efd4d0;
  border-radius: 9px;
  color: #7c514d;
  background: #fff7f6;
  font-size: 11px;
  gap: 16px;
}

.inline-error strong {
  margin-right: 6px;
  color: #944b45;
}

.inline-error button {
  min-height: 30px;
  padding: 0 10px;
  border: 1px solid #dfbcb7;
  border-radius: 7px;
  color: #8d4841;
  background: #fff;
  cursor: pointer;
  font-size: 11px;
  font-weight: 700;
}

.preview-note {
  margin-bottom: 12px;
  padding: 10px 13px;
  border: 1px solid #ead9be;
  border-radius: 9px;
  color: #795b35;
  background: #fffaf2;
  font-size: 11px;
}

.state-card {
  min-height: 330px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border: 1px dashed #d5dfdb;
  border-radius: 11px;
  color: #718078;
  background: #fff;
  text-align: center;
}

.state-card > strong {
  color: #34483f;
  font-size: 14px;
}

.state-card > span {
  margin-top: 5px;
  font-size: 11px;
}

.primary-link, .secondary-button {
  min-height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-top: 14px;
  border-radius: 9px;
  padding: 0 13px;
  cursor: pointer;
  font-size: 11px;
  font-weight: 750;
  text-decoration: none;
}

.primary-link {
  border: 0;
  color: #fff;
  background: #147b57;
}

.secondary-button {
  border: 1px solid #cfdbd5;
  color: #456158;
  background: #fff;
}

.drive-list {
  overflow: hidden;
  border: 1px solid #e0e7e4;
  border-radius: 11px;
  background: #fff;
}

.drive-head, .drive-row {
  width: 100%;
  display: grid;
  align-items: center;
  padding: 0 14px;
  grid-template-columns: minmax(320px, 1.7fr) 120px minmax(190px, 0.9fr) 150px 36px;
  gap: 14px;
}

.drive-head {
  min-height: 42px;
  border-bottom: 1px solid #e2e8e5;
  color: #61736b;
  background: #fafbfb;
  font-size: 12px;
  font-weight: 700;
}

.drive-row {
  min-height: 82px;
  border: 0;
  border-bottom: 1px solid #edf1ef;
  color: #4f625a;
  background: #fff;
  cursor: pointer;
  font-size: 12px;
  text-align: left;
}

.drive-row:last-of-type {
  border-bottom: 0;
}

.drive-row:hover {
  background: #f5f8f7;
}

.drive-row:focus-visible {
  outline: 2px solid #4b957b;
  outline-offset: -2px;
}

.qa-copy, .source-copy {
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.qa-copy strong {
  overflow: hidden;
  color: #243a31;
  font-size: 13px;
  line-height: 1.45;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.qa-copy small {
  display: -webkit-box;
  overflow: hidden;
  margin-top: 5px;
  color: #697a73;
  font-size: 12px;
  line-height: 1.45;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.source-copy strong {
  overflow: hidden;
  color: #3a5148;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.source-copy small {
  overflow: hidden;
  margin-top: 4px;
  color: #829089;
  font-size: 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.qa-state {
  width: fit-content;
  display: inline-flex;
  align-items: center;
  padding: 4px 7px;
  border-radius: 6px;
  color: #61706a;
  background: #eef2f0;
  font-size: 10px;
  font-style: normal;
  font-weight: 800;
  white-space: nowrap;
  gap: 5px;
}

.qa-state i {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: currentColor;
}

.qa-state[data-status=PASSED] {
  color: #116c4a;
  background: #dcf2e7;
}

.qa-state[data-status=REVIEW_REQUIRED] {
  color: #936321;
  background: #fff1d9;
}

.qa-state[data-status=REJECTED] {
  color: #a34b43;
  background: #fae9e7;
}

.qa-state[data-status=PREVIEW] {
  color: #6a6684;
  background: #efedf7;
}

.created-date {
  color: #71817a;
  font-size: 11px;
}

.row-arrow {
  display: grid;
  place-items: center;
}

.row-arrow svg {
  width: 18px;
  height: 18px;
  fill: none;
  stroke: #8e9d96;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.8;
}

.run-pagination {
  min-height: 48px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 14px;
  border-top: 1px solid #e8eeeb;
  color: #7d8b85;
  font-size: 11px;
}

.run-pagination > div {
  display: flex;
  gap: 8px;
}

.run-pagination button {
  width: 28px;
  height: 28px;
  border: 1px solid #d8e2dd;
  border-radius: 7px;
  color: #53675f;
  background: #fff;
  cursor: pointer;
}

.run-pagination button:disabled {
  cursor: default;
  opacity: 0.4;
}

.detail-scrim {
  position: fixed;
  z-index: 40;
  inset: 0;
  background: rgba(17, 31, 26, 0.3);
}

.detail-panel {
  position: fixed;
  z-index: 41;
  top: 0;
  right: 0;
  bottom: 0;
  width: min(720px, 96vw);
  overflow-y: auto;
  padding: 24px;
  background: #fff;
  box-shadow: -16px 0 42px rgba(17, 36, 29, 0.18);
}

.detail-loading {
  padding: 60px 20px;
  color: #6c7b75;
  text-align: center;
}

.detail-header {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e4ebe8;
}

.detail-header > div > span {
  color: #18845f;
  font-size: 10px;
  font-weight: 800;
}

.detail-header h2 {
  margin: 5px 0 9px;
  color: #20352c;
  font-size: 21px;
}

.detail-header > button {
  width: 34px;
  height: 34px;
  flex: 0 0 auto;
  border: 0;
  border-radius: 50%;
  color: #4f625a;
  background: #eef3f1;
  cursor: pointer;
  font-size: 22px;
}

.detail-notice {
  margin-top: 14px;
  padding: 11px 13px;
  border-radius: 9px;
  color: #6c5d3f;
  background: #fff7e9;
  font-size: 11px;
}

.qa-panel, .evidence-panel, .evaluation-panel, .validation-panel {
  margin-top: 14px;
  padding: 17px;
  border: 1px solid #e0e8e4;
  border-radius: 12px;
}

.qa-panel > span, .answer-divider span, .evidence-panel > header > span, .validation-panel > header > span {
  color: #177958;
  font-size: 10px;
  font-weight: 800;
}

.qa-panel h3 {
  margin: 9px 0 16px;
  color: #243a31;
  font-size: 16px;
  line-height: 1.55;
}

.answer-divider {
  padding-top: 14px;
  border-top: 1px solid #e7ecea;
}

.qa-panel > p {
  margin: 9px 0 0;
  color: #40534b;
  font-size: 13px;
  line-height: 1.75;
  white-space: pre-wrap;
}

.evidence-panel {
  background: #f8fbfa;
}

.evidence-panel > header, .validation-panel > header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.evidence-panel > header em {
  padding: 4px 6px;
  border-radius: 5px;
  color: #26785b;
  background: #def2e9;
  font-size: 9px;
  font-style: normal;
}

.evidence-panel > header em.warning {
  color: #9f4b44;
  background: #fae7e5;
}

.evidence-panel dl, .technical-detail dl {
  margin: 13px 0;
  border-top: 1px solid #dfe8e4;
}

.evidence-panel dl div, .technical-detail dl div {
  display: grid;
  grid-template-columns: 88px 1fr;
  gap: 10px;
  padding: 8px 0;
  border-bottom: 1px solid #e5ece9;
}

.evidence-panel dt, .technical-detail dt {
  color: #819089;
  font-size: 10px;
}

.evidence-panel dd, .technical-detail dd {
  overflow-wrap: anywhere;
  margin: 0;
  color: #3d5048;
  font-size: 11px;
}

.evidence-panel blockquote {
  margin: 12px 0 0;
  padding: 13px;
  border: 0;
  border-radius: 9px;
  color: #3e5149;
  background: #fff;
  font-size: 12px;
  line-height: 1.7;
  white-space: pre-wrap;
}

.evaluation-panel {
  border-color: #dfe1f1;
  background: #f8f8fd;
}

.evaluation-panel > header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.evaluation-panel > header span, .evaluation-panel > header strong {
  display: block;
}

.evaluation-panel > header span {
  color: #626ba8;
  font-size: 9px;
  font-weight: 850;
  letter-spacing: 0.04em;
}

.evaluation-panel > header strong {
  margin-top: 3px;
  color: #3f477a;
  font-size: 12px;
}

.evaluation-panel > header em {
  padding: 7px 9px;
  border-radius: 8px;
  color: #fff;
  background: #5964a3;
  font-size: 12px;
  font-style: normal;
  font-weight: 850;
}

.evaluation-scores {
  display: grid;
  margin-top: 13px;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 7px;
}

.evaluation-scores article {
  padding: 9px;
  border: 1px solid #e2e4f2;
  border-radius: 8px;
  background: #fff;
}

.evaluation-scores span, .evaluation-scores strong {
  display: block;
}

.evaluation-scores span {
  color: #8589a6;
  font-size: 8px;
}

.evaluation-scores strong {
  margin-top: 3px;
  color: #4c568e;
  font-size: 13px;
}

.evaluation-scores small {
  margin-left: 2px;
  color: #989bb0;
  font-size: 8px;
}

.evaluation-panel ul {
  margin: 12px 0 0;
  padding-left: 18px;
  color: #565c80;
  font-size: 11px;
  line-height: 1.6;
}

.evaluation-panel blockquote {
  margin: 12px 0 0;
  padding: 11px 12px;
  border-left: 3px solid #858dc0;
  color: #666b86;
  background: #fff;
  font-size: 10px;
  line-height: 1.6;
}

.evaluation-panel > footer {
  display: flex;
  justify-content: space-between;
  margin-top: 12px;
  color: #8b8ea2;
  font-size: 8px;
  gap: 8px;
}

.evaluation-panel > footer code {
  overflow-wrap: anywhere;
  color: #6d739d;
}

.missing-evidence {
  color: #855834;
  font-size: 11px;
}

.validation-panel > header strong {
  color: #496158;
  font-size: 11px;
}

.validation-panel ul {
  margin: 12px 0 0;
  padding-left: 18px;
  color: #6f563d;
  font-size: 11px;
  line-height: 1.6;
}

.check-list {
  display: flex;
  flex-wrap: wrap;
  margin-top: 12px;
  gap: 6px;
}

.check-list span {
  padding: 5px 7px;
  border-radius: 6px;
  color: #277458;
  background: #edf6f2;
  font-family: monospace;
  font-size: 9px;
}

.check-list span[data-status=FAILED] {
  color: #a34b43;
  background: #fae9e7;
}

.technical-detail {
  margin-top: 14px;
  padding: 14px 16px;
  border: 1px solid #e3e9e6;
  border-radius: 10px;
}

.technical-detail summary {
  color: #63736c;
  cursor: pointer;
  font-size: 11px;
  font-weight: 700;
}

.technical-detail code {
  color: #50635b;
  font-size: 9px;
}

.lineage-list {
  display: grid;
  margin: 0;
  padding: 0;
  list-style: none;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 7px;
}

.lineage-list li {
  min-width: 0;
  padding: 9px;
  border-radius: 7px;
  background: #f4f7f6;
}

.lineage-list span, .lineage-list code {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.lineage-list span {
  color: #567067;
  font-size: 9px;
  font-weight: 700;
}

.lineage-list code {
  margin-top: 3px;
}

.detail-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 16px;
  padding-top: 14px;
  border-top: 1px solid #e5ebe8;
}

.detail-footer a, .detail-footer button {
  border: 0;
  border-radius: 8px;
  padding: 10px 13px;
  font-size: 10px;
  font-weight: 750;
  text-decoration: none;
}

.detail-footer a {
  margin-right: auto;
  color: #1e7555;
  background: #e6f4ee;
}

.detail-footer button {
  color: #51645c;
  background: #edf1ef;
}

.sr-only {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
}

@media (max-width: 1050px) {
  .drive-head, .drive-row {
    grid-template-columns: minmax(280px, 1.5fr) 110px minmax(170px, 0.8fr) 36px;
  }
  .drive-head > span:nth-child(4), .created-date {
    display: none;
  }
  .drive-command-bar {
    align-items: stretch;
    flex-direction: column;
  }
  .list-utilities {
    width: 100%;
    justify-content: flex-start;
    margin-left: 0;
  }
  .command-icon-button {
    margin-left: auto;
  }
}
@media (max-width: 760px) {
  .candidate-drive {
    padding: 16px 12px 28px;
  }
  .drive-shell {
    min-height: 0;
  }
  .drive-navigation-bar {
    align-items: stretch;
    flex-direction: column;
    padding: 13px 14px;
    gap: 9px;
  }
  .breadcrumbs > span {
    max-width: 120px;
  }
  .drive-search {
    width: 100%;
    min-width: 0;
    max-width: none;
    flex-basis: auto;
  }
  .drive-command-bar {
    padding: 9px 14px;
  }
  .status-filters {
    width: 100%;
  }
  .list-utilities {
    flex-wrap: wrap;
  }
  .run-filter {
    flex: 1 1 220px;
  }
  .run-filter select {
    width: 100%;
    max-width: none;
  }
  .location-count {
    order: 3;
    width: 100%;
    max-width: none;
  }
  .drive-content {
    padding: 14px;
  }
  .drive-head {
    display: none;
  }
  .drive-row {
    grid-template-columns: 1fr 28px;
    padding: 13px;
    gap: 9px;
  }
  .qa-copy {
    grid-column: 1;
  }
  .qa-state {
    grid-column: 1;
    grid-row: 2;
  }
  .source-copy {
    grid-column: 1;
    grid-row: 3;
  }
  .row-arrow {
    grid-column: 2;
    grid-row: 1;
  }
  .created-date {
    display: none;
  }
  .inline-error {
    align-items: flex-start;
    flex-direction: column;
  }
  .detail-panel {
    width: 100%;
    padding: 16px;
  }
  .lineage-list {
    grid-template-columns: 1fr;
  }
  .detail-footer {
    align-items: stretch;
    flex-direction: column;
  }
  .detail-footer a {
    margin-right: 0;
    text-align: center;
  }
}`],
})
export class PageAuthoringCandidatesComponent implements OnInit {
    public loading: boolean = true;
    public detailLoading: boolean = false;
    public loadError: string = '';
    public items: any[] = [];
    public selected: any = null;
    public contextDataset: any = {};
    public summary: any = {
        total: 0,
        review_required: 0,
        passed: 0,
        rejected: 0,
        preview: 0,
        publishable: 0,
        publish_blocked: 0
    };
    public filterOptions: any = {
        runs: [],
        validation_statuses: [],
        candidate_statuses: []
    };
    public pagination: any = {
        page: 1,
        page_size: 20,
        total: 0,
        pages: 1
    };
    public filters: any = {
        q: '',
        run_id: '',
        validation_status: '',
        candidate_status: ''
    };
    public statusFilter: string = 'ALL';
    public statusOptions: any[] = [
        { value: 'ALL', label: '전체' },
        { value: 'PASSED', label: '평가 통과' },
        { value: 'REVIEW_REQUIRED', label: '검수 필요' }
    ];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        let params = new URLSearchParams(location.search);
        let requestedDatasetId = params.get('dataset_id') || '';
        this.filters.run_id = params.get('run_id') || '';
        this.filters.q = params.get('q') || '';
        let requestedStatus = params.get('status') || 'ALL';
        this.applyStatusFilter(
            this.statusOptions.some((item: any) => item.value === requestedStatus)
                ? requestedStatus
                : 'ALL'
        );
        if (
            requestedDatasetId
            && requestedDatasetId !== this.currentDataset().dataset_id
        ) {
            let selected = await this.selectDatasetContext(requestedDatasetId);
            if (!selected) {
                this.loading = false;
                await this.service.render();
                return;
            }
        }
        await this.load(1);
    }

    public currentDataset() {
        return this.service.auth.session.current_dataset || {};
    }

    public currentDatasetName() {
        return this.contextDataset.name
            || this.currentDataset().dataset_name
            || 'QA 데이터셋';
    }

    private async selectDatasetContext(datasetId: string) {
        try {
            let result: any = await this.service.request.post('/api/datasets/select', {
                dataset_id: datasetId
            });
            if (result.code !== 200) {
                this.loadError = result.data && result.data.message
                    ? String(result.data.message)
                    : 'QA 데이터셋을 열지 못했습니다.';
                return false;
            }
            let access = result.data.access || {};
            this.service.auth.session.current_dataset = access.current_dataset || {};
            this.service.auth.session.dataset_roles = access.dataset_roles || [];
            this.service.auth.session.portals = access.portals || this.service.auth.session.portals;
            return true;
        } catch (error) {
            this.loadError = '서버 연결을 확인한 뒤 다시 시도해 주세요.';
            return false;
        }
    }

    private async showError(message: string) {
        await this.service.modal.show({
            title: '조회 실패',
            message: message,
            cancel: false,
            action: '확인',
            actionBtn: 'error',
            status: 'error'
        });
    }

    public async load(page: number = 1) {
        let dataset = this.currentDataset();
        if (!dataset.dataset_id) {
            this.loading = false;
            this.loadError = '조회할 QA 데이터셋이 선택되지 않았습니다.';
            await this.service.render();
            return;
        }
        this.loading = true;
        this.loadError = '';
        await this.service.render();
        try {
            let result: any = await this.service.request.post('/api/generation/candidates/list', {
                dataset_id: dataset.dataset_id,
                q: this.filters.q,
                run_id: this.filters.run_id,
                validation_status: this.filters.validation_status,
                candidate_status: this.filters.candidate_status,
                page: page,
                page_size: this.pagination.page_size
            });
            if (result.code !== 200) {
                this.items = [];
                this.loadError = result.data && result.data.message
                    ? String(result.data.message)
                    : '생성 QA 목록을 불러오지 못했습니다.';
                return;
            }
            this.contextDataset = result.data.dataset || {};
            this.items = result.data.items || [];
            this.summary = result.data.summary || this.summary;
            this.filterOptions = result.data.filter_options || this.filterOptions;
            this.pagination = result.data.pagination || this.pagination;
            if (
                this.filters.run_id
                && !this.filterOptions.runs.some(
                    (run: any) => run.id === this.filters.run_id
                )
            ) {
                this.items = [];
                this.loadError = '선택한 QA 생성 이력을 현재 데이터셋에서 찾을 수 없습니다.';
            }
            this.syncUrl();
        } catch (error) {
            this.items = [];
            this.loadError = '서버 연결을 확인한 뒤 다시 시도해 주세요.';
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    private applyStatusFilter(value: string) {
        this.statusFilter = value;
        this.filters.validation_status = '';
        this.filters.candidate_status = '';
        if (value === 'PASSED') this.filters.validation_status = 'PASSED';
        if (value === 'REVIEW_REQUIRED') {
            this.filters.validation_status = 'REVIEW_REQUIRED';
        }
    }

    public async setStatusFilter(value: string) {
        this.applyStatusFilter(value);
        await this.load(1);
    }

    public statusCount(value: string) {
        let counts: any = {
            ALL: this.summary.total,
            PASSED: this.summary.passed,
            REVIEW_REQUIRED: this.summary.review_required
        };
        return Number(counts[value] || 0);
    }

    public async changeRunFilter(value: string) {
        this.filters.run_id = value || '';
        this.selected = null;
        await this.load(1);
    }

    public async submitSearch() {
        await this.load(1);
    }

    public async clearSearch() {
        this.filters.q = '';
        await this.load(1);
    }

    public async clearFilters() {
        this.filters.q = '';
        this.filters.run_id = '';
        this.applyStatusFilter('ALL');
        await this.load(1);
    }

    private syncUrl() {
        let params = new URLSearchParams();
        let datasetId = this.currentDataset().dataset_id || '';
        if (datasetId) params.set('dataset_id', datasetId);
        if (this.filters.run_id) params.set('run_id', this.filters.run_id);
        if (this.filters.q) params.set('q', this.filters.q);
        if (this.statusFilter !== 'ALL') params.set('status', this.statusFilter);
        let query = params.toString();
        history.replaceState(
            {},
            '',
            '/authoring/candidates' + (query ? '?' + query : '')
        );
    }

    public generationQuery(runId: string = '') {
        let query: any = {
            dataset_id: this.currentDataset().dataset_id
        };
        if (runId) query.run_id = runId;
        return query;
    }

    public selectedRun() {
        return this.filterOptions.runs.find(
            (run: any) => run.id === this.filters.run_id
        ) || null;
    }

    public contextTitle() {
        let run = this.selectedRun();
        return run ? run.run_name : '전체 생성 결과';
    }

    public async openDetail(item: any) {
        this.detailLoading = true;
        await this.service.render();
        try {
            let result: any = await this.service.request.post('/api/generation/candidates/detail', {
                dataset_id: this.currentDataset().dataset_id,
                candidate_id: item.id
            });
            if (result.code !== 200) {
                await this.showError(
                    result.data && result.data.message
                        ? result.data.message
                        : '생성 QA 상세를 불러오지 못했습니다.'
                );
                return;
            }
            this.selected = result.data.item;
        } catch (error) {
            await this.showError('서버 연결을 확인한 뒤 다시 시도해 주세요.');
        } finally {
            this.detailLoading = false;
            await this.service.render();
        }
    }

    public async closeDetail() {
        this.selected = null;
        await this.service.render();
    }

    public hasFilters() {
        return !!(
            this.filters.q
            || this.filters.run_id
            || this.statusFilter !== 'ALL'
        );
    }

    public candidateState(item: any) {
        if (item.is_preview) return 'PREVIEW';
        if (
            item.status === 'AUTO_REJECTED'
            || item.validation_status === 'REJECTED'
            || item.validation_status === 'FAILED'
        ) return 'REJECTED';
        if (item.validation_status === 'PASSED') return 'PASSED';
        return 'REVIEW_REQUIRED';
    }

    public candidateStateLabel(item: any) {
        let labels: any = {
            PREVIEW: '미리보기',
            PASSED: '평가 통과',
            REVIEW_REQUIRED: '검수 필요',
            REJECTED: '평가 제외'
        };
        return labels[this.candidateState(item)] || '생성됨';
    }

    public sourceTitle(item: any) {
        return (item.evidence || {}).source_title || '원천 문서';
    }

    public sourceMeta(item: any) {
        let evidence = item.evidence || {};
        return [evidence.source_group, evidence.locator]
            .filter((value: string) => !!value)
            .join(' · ') || '상세에서 근거 확인';
    }

    public validationLabel(value: string) {
        let labels: any = {
            REVIEW_REQUIRED: '검수 필요',
            PASSED: '평가 통과',
            REJECTED: '평가 제외',
            FAILED: '평가 실패'
        };
        return labels[value] || value || '-';
    }

    public candidateStatusLabel(value: string) {
        let labels: any = {
            REVIEW_READY: '검수 대기',
            AUTO_ACCEPTED: '자동 승인',
            AUTO_REJECTED: '자동 제외',
            GENERATED: '생성됨'
        };
        return labels[value] || value || '-';
    }

    public evaluationVerdictLabel(value: string) {
        let labels: any = {
            PASS: '통과 권고',
            REVIEW: '전문가 검수 권고',
            REJECT: '제외 권고',
            NOT_EVALUATED: '규칙 검사에서 제외'
        };
        return labels[value] || value || '-';
    }

    public lineageLabel(value: string) {
        let labels: any = {
            SOURCE_VERSION: '원천 버전',
            TEXT_UNIT: 'TextUnit',
            GENERATION_RUN: 'QA 생성 이력',
            QA_CANDIDATE: '생성 QA'
        };
        return labels[value] || value;
    }

    public formatDate(value: string) {
        return formatKstDateTime(value, '-');
    }

    public shortHash(value: string) {
        return value ? value.substring(0, 12) : '-';
    }
}

export default PageAuthoringCandidatesComponent;